// extracted by mini-css-extract-plugin
export default {"description":"hIUSAdli6XcTbiIoLofw","header":"XQnuPW0j_PuB3evye_3U"};